$(function () {

    if (!$('.translation-form').length) return false;

    /**
     * Load the available languages
     */

    loadATLLanguages(function () {
        // add the first empty file to the form
        addTranslationFile();
    });

    // retrieve the original translation request to fill up the form 
    if (getURLParameter("translation_id")) {
        $(".translation-form").loadATLObject({
            endpoint: "translations",
            objectId: getURLParameter("translation_id") + '?responseGroups=FILES',
            errorMessage: "Sorry, we couldn't retrieve the translation you are looking for.",
            errorRedirectURL: config.app_url + "/clients/my-translations/",
            fieldsFormats: {

            },
            success: function(translation) {       
                $('.translation-form input, .translation-form select, .translation-form textarea').each(function () {
                    let name = $(this).attr('name');
                    if (translation[name] !== undefined) {
                        $(this).val(translation[name]);
                    }
                });

                // display list of translation files
                $('#translation-files-list').html(displayTranslationFilesList(translation.translation_files));
            }
        });
    }


    // user clicks on "Add another"
    $('#add-other-file').on('click', function (e) {
        e.preventDefault();

        addTranslationFile();

        $("#add-other-row").hide();
    });


    /**
     * Add a file form to the translation form
     */
    function addTranslationFile() {

        let fileIndex = $('.translation-files-input').length;

        let fileHTML = `
            <tr class="provide-files-row-${fileIndex}">
                <td class="lbl"><label for="attachments-${fileIndex}">Please attach your Document/s (max 2Mb)</label></td>
                <td>
                    <input class="full-width border-box translation-files-input" type="file" name="attachments_${fileIndex}" id="attachments-${fileIndex}" value="" multiple />
                    <p class="padded-top-5 small-text">Alternatively please print this form and Fax with your Document/s to 9221 4763 Or post to GPO Box 4136 Sydney 2001</p>
                </td>
            </tr>
            <tr class="provide-files-row-${fileIndex}">
                <td></td>
                <td><a id="only-files-names-${fileIndex}" class="only-files-names">I can't provide the files right now</a></td>
            </tr>
            <tr class="only-files-names-row-${fileIndex}" style="display:none">
                <td class="lbl"><label for="files-names-${fileIndex}" class="red-text">Please provide name/s of your Document/s</label></td>
                <td>
                    <input class="full-width border-box files-names" type="text" name="files_names_${fileIndex}" id="files-names-${fileIndex}" />
                    <p class="padded-top-5 small-text">Please separate files names with commas (,)</p>
                </td>
            </tr>
            <tr class="only-files-names-row-${fileIndex}" style="display:none">
                <td></td>
                <td><a id="provide-files-${fileIndex}" class="provide-files">I can provide the files right now</a></td>
            </tr>
            <tr>
                <td class="lbl" style="padding-top:18px">Languages <span class="mandatoryField">*</span></td>
                <td>
                    <table>
                        <tr>
                            <td><label for="language-from-${fileIndex}">FROM</label></td>
                            <td>
                                <select name="language_from_${fileIndex}" id="language-from-${fileIndex}" class="file-language-select">
                                    <option value="">Select a language</option>
                                    <option value="Other">Other</option>
                                    ${getLanguagesOptions()}
                                </select>
                            </td>
                            <td><input type="text" name="language_from_name_${fileIndex}" id="language-from-name-${fileIndex}" placeholder="Language From" style="display:none"></td>
                        </tr>
                        <tr>
                            <td><label for="language-to-${fileIndex}">TO</label></td>
                            <td>
                                <select name="language_to_${fileIndex}" id="language-to-${fileIndex}" class="file-language-select">
                                    <option value="">Select a language</option>
                                    <option value="Other">Other</option>
                                    ${getLanguagesOptions()}
                                </select>
                            </td>
                            <td><input type="text" name="language_to_name_${fileIndex}" id="language-to-name-${fileIndex}" placeholder="Language To" style="display:none"></td>

                        </tr>
                    </table>
                </td>
            </tr>
        `;

        $('#translation-files-table').append(fileHTML);
        $('#attachments-' + fileIndex).customFile();
    }


    // user clicks on "I can't provide the files right now"
    $('#translation-files-table').on('click', '.only-files-names', function (e) {
        let fileIndex = this.id.match(/only-files-names-(\d*)/)[1];

        $(".provide-files-row-" + fileIndex).each(function () {
            $(this).hide();
        });

        $(".only-files-names-row-" + fileIndex).each(function () {
            $(this).show();
        });
    });


    // user clicks on "I can provide the files"
    $('#translation-files-table').on('click', '.provide-files', function (e) {
        let fileIndex = this.id.match(/provide-files-(\d*)/)[1];

        $(".only-files-names-row-" + fileIndex).each(function () {
            $(this).hide();
        });

        $(".provide-files-row-" + fileIndex).each(function () {
            $(this).show();
        });
    });


    function getAllFiles() {
        let translationFiles = [];

        let filesCount = $('.translation-files-input').length;

        for (let i = 0; i < filesCount; i++) {
            translationFiles.push({
                files: $('#attachments-' + i).prop('files'),
                files_names: $('#files-names-' + i).val(),
                language_from: $('#language-from-' + i).val(),
                language_to: $('#language-to-' + i).val(),
            });
        }

        return translationFiles;
    }


    // user selected a file to upload
    $('#translation-files-table').on('change', '.translation-files-input', function (e) {
        let input = this;
        let fileIndex = input.id.match(/attachments-(\d*)/)[1];

        if (input.files.length > 0) {
            $("#only-files-names-" + fileIndex).hide();
            document.getElementById("add-other-row").style.display = "none";
        }
        else { // user removed entered files 
            $("#only-files-names-" + fileIndex).show();
        }

        // show "Add another file" button if all previous files forms have been completed
        let translationFiles = getAllFiles();
        let allFilesCompleted = true;
        for (let translationFile of translationFiles) {
            if (translationFile.files.length == 0 && translationFile.files_names === "") {
                allFilesCompleted = false;
                break;
            }
        }

        if (allFilesCompleted) {
            $("#add-other-row").show();
        }
        else {
            $("#add-other-row").hide();
        }
    });


    // user manually entered the name of the files to translate
    $('#translation-files-table').on('input', '.files-names', function (e) {
        // show "Add another file" button if all previous files forms have been completed
        let translationFiles = getAllFiles();
        let allFilesCompleted = true;
        for (let translationFile of translationFiles) {
            if (translationFile.files.length == 0 && translationFile.files_names === "") {
                allFilesCompleted = false;
                break;
            }
        }

        if (allFilesCompleted) {
            $("#add-other-row").show();
        }
        else {
            $("#add-other-row").hide();
        }
    });


    // user selects languages for translation file
    $('.translation-form').on('change', '.file-language-select', function (e) {
        let select = this;
        let language_from = select.id.match(/language-from-(\d*)/);
        let language_to = select.id.match(/language-to-(\d*)/);
        let opposite;

        // toggle "Other" language field
        if (language_from) {
            let i = language_from[1];
            if ($(select).val() === "Other") {
                $("#language-from-name-" + i).show();
            }
            else {
                $("#language-from-name-" + i).hide();
            }
            opposite = $("#language-to-" + i);
        }
        else if (language_to) {
            let i = language_to[1];
            if ($(select).val() === "Other") {
                $("#language-to-name-" + i).show();
            }
            else {
                $("#language-to-name-" + i).hide();
            }
            opposite = $("#language-from-" + i);
        }

        // force one of the 2 languages to be English
        if ($(select).val() !== "English") {
            $(opposite).val("English");
            $(opposite).attr("disabled", "");
        }
        else {
            $(opposite).attr("disabled", null);
        }
    });

    // load templates 
    if ($('#select-translation-template').length) {
        $.ajax({
            url: getApiURL("translation_templates"),
            headers: { "Token": $.cookie('token_api') },
            data: {
                fields: 'ID,name',
                sort: 'name'
            },
            dataType: "json",
            success: function (templates) {
                let templateOptions = '';
                templates.forEach(template => {
                    templateOptions += `<option value="${template.ID}">${template.name}</option>`;
                });
                $('#select-translation-template').append(templateOptions);
            }
        });
    }

    // user selects template
    $('form#new-translation-form #select-translation-template').on('change', function () {
        let template_id = parseInt($(this).val());

        if (template_id != 0) {
            $.ajax({
                url: getApiURL("translation_templates") + "/" + template_id,
                headers: { "Token": $.cookie('token_api') },
                dataType: "json",
                success: function (data) {
                    // input fields (not radio)
                    $('form#new-translation-form input:not([type=submit]):not(:radio), form#new-translation-form textarea, form#new-translation-form select').each(function () {
                        let input = this;
                        if (data[$(input).attr('name')] != undefined) {
                            $(input).val(data[$(input).attr('name')]);
                        }

                        //hack for confirmation email
                        if (input.id === "confirm-email") {
                            $(input).val(data["email"]);
                        }
                    });

                    // radio fields
                    $('form#new-translation-form input:radio').each(function () {
                        let radio = this;
                        if (data[$(radio).attr('name')]) {
                            if ($(radio).is("[value=" + data[$(radio).attr('name')] + "]")) {
                                $(radio).prop("checked", true);
                            } else {
                                $(radio).prop("checked", false);
                            }
                        }
                    });

                    if (data['request_quote'] != "0") {
                        $('form#new-translation-form #request_quote').prop("checked", true);
                    }
                    else {
                        $('form#new-translation-form #request_quote').prop("checked", false);
                    }
                    // Fix: remove the value for that checkbox to prevent sending wrong information
                    $('form#new-translation-form #request_quote').val('');

                    $("select.state-field").trigger("change");
                }
            });
        }
        else {
            $('form#new-translation-form input:not([type=submit]):not(:radio), form#new-translation-form textarea, form#new-translation-form select').each(function () {
                $(this).val("");
            });

            $('form#new-translation-form #request_quote').prop("checked", false);

            $("select.state-field").trigger("change");
        }
    });


    // user submits translation form
    $('#submit-translation-form').on('click', function (e) {
        e.preventDefault();

        let form = $('form.translation-form');
        let form_data = getFormData(form);

        if (form_data['company'] === "") {
            alert("Please fill out the Name of Company / Individual field.");
            return false;
        }

        if (form_data['street_address'] === "") {
            alert("Please fill out the Street Address field.");
            return false;
        }

        if (form_data['state'] === "" || form_data['postcode'] === "" || form_data['suburb'] === "") {
            alert("Please fill out the City, Suburb and Postcode fields.");
            return false;
        }

        if (form_data['telephone'] === "") {
            alert("Please fill out the Telephone field");
            return false;
        }

        if (form_data['email'] === "") {
            alert("Please fill out the Email Address field");
            return false;
        }

        let email = form_data['email'];
        if (!isValidEmail(email)) {
            alert("Please enter a valid Email Address");
            return false;
        }

        if (email != $(form).find('#confirm-email').val()) {
            alert("The email and confirmation email addresses do not match");
            return false;
        }

        if ($(form).find("#additional-email-checkbox").is(":checked") && !isValidEmail($(form).find('#additional-email').val())) {
            alert("Please enter a valid Additional Email Address");
            return false;
        }

        let from = $("[name=language_from]");
        let to = $("[name=language_to]");

        for (let i = 0; i < from.length; i++) {
            let from_field = from[i];
            let to_field = to[i];

            if (from_field.value === "" || from_field.value === "Other" && $('#language-from-name-' + i).val() === "") {
                alert("Please fill out the Language From field #" + (i + 1));
                return false;
            }

            if (to_field.value === "" || to_field.value === "Other" && $('#language-to-name-' + i).val() === "") {
                alert("Please fill out the Language To field #" + (i + 1));
                return false;
            }

            if (from_field.value !== "English" && to_field.value !== "English") {
                alert("At least the Language From or the Language To must be English for file #" + (i + 1));
                return false;
            }
        };

        if (form_data['client'] === "") {
            alert("Please fill out the Client's Name field");
            return false;
        }

        if (form_data['job_reference'] === "") {
            alert("Please fill out the Claim No / Job Ref field");
            return false;
        }

        if (form_data['invoice_company'] === "") {
            alert("Please fill out the Invoice Company field");
            return false;
        }

        if (form_data['invoice_state'] === "" || form_data['invoice_postcode'] === "" || form_data['invoice_suburb'] === "") {
            alert("Please fill out the Invoice City, Suburb and Postcode fields.");
            return false;
        }

        if (form_data['instructed_by'] === "") {
            alert("Please fill out the Instructed By field");
            return false;
        }

        if (form_data['contact_phone'] === "") {
            alert("Please fill out the Contact Phone No. field");
            return false;
        }

        if ($(form).find('#undertaking:checked').length == 0) {
            alert("Please agree to the terms");
            return false;
        }

        // format the translation data to send
        let formData = new FormData(form[0]);

        let formFiles = getAllFiles();
        let fileProvided = false;
        let totalSize = 0;
        let attachments = [];
        let attachmentIndex = 0;
        let attachmentsToSendLater = [];
        for (let i = 0; i < formFiles.length; i++) {
            // unattach files as they will be formatted and added below
            formData.delete('attachments_' + i);

            let formFile = formFiles[i];
            if (formFile.files.length > 0) { // at least one file to upload
                fileProvided = true;
                for (let j = 0; j < formFile.files.length; j++) {
                    let fileToUpload = formFile.files[j];
                    formData.append('translation_files[' + attachmentIndex + '][file]', fileToUpload.name);
                    formData.append('translation_files[' + attachmentIndex + '][language_from]', formFile.language_from);
                    formData.append('translation_files[' + attachmentIndex + '][language_to]', formFile.language_to);
                    attachments.push(fileToUpload);
                    totalSize += fileToUpload.size;
                    attachmentIndex++;
                }
            }
            else if (formFile.files_names !== "") { // only files names provided
                fileProvided = true;
                let filesNames = formFile.files_names.split(',');
                for (let j = 0; j < filesNames.length; j++) {
                    let fileName = filesNames[j];
                    formData.append('translation_files[' + attachmentIndex + '][file]', fileName.trim());
                    formData.append('translation_files[' + attachmentIndex + '][language_from]', formFile.language_from);
                    formData.append('translation_files[' + attachmentIndex + '][language_to]', formFile.language_to);
                    attachmentIndex++;
                    attachmentsToSendLater.push(fileName.trim());
                }
            }
            // ignore files which haven't been selected
        };

        if (!fileProvided) {
            alert("Please select at least one document to be translated, or provide its name.");
            return false;
        }

        var attachmentsToLarge = totalSize > MAX_FILES_UPLOAD_SIZE; // files too big, don't upload them
        if (!attachmentsToLarge) {
            for (let fileToUpload of attachments) {
                formData.append('attachments[' + fileToUpload.name + ']', fileToUpload);
            }
        }

        // Manage the Request quote value
        formData.delete('request_quote');
        formData.append('request_quote', $("#request_quote").is(':checked') ? 1 : 0);

        // display confirmation / duplicate dialog 
        if ($(form).attr('id') === "new_translation") { // logged out form
            const dialog = showConfirmationDialog({
                title: "Submit this translation request?",
                body: "Are you sure you want to submit this translation request form?",
                confirmButton: {
                    title: "Confirm",
                    onClick: function () {
                        $('.modal-body', dialog).prepend(`<p>Uploading file(s), please wait...</p>`);
                        $.ajax({
                            type: "POST",
                            url: `${getApiURL("translations")}/logged-out`,
                            data: formData,
                            contentType: false,
                            processData: false,
                            success: function (data) {
                                let translationRef = data.ref;
                                let requestType = data.request_quote ? "quote request" : "translation request";
                                if (attachmentsToLarge) { // warn user files were too large to be attached
                                    ATLAlerts.addWarning(`The ${requestType} has been successfully created. However your filesize exceeded the limit size (${Math.round(MAX_FILES_UPLOAD_SIZE/1000000)}Mb). Please send directly the files to ATL administration.`);
                                }
                                else {
                                    ATLAlerts.addSuccess(`The ${requestType} ${translationRef} has been successfully created.`);
                                    attachmentsToSendLater.forEach(filename => {
                                        ATLAlerts.addWarning(`Don't forget to send us the document ${filename}.`);
                                    });
                                }
                                // dialog.modal('hide');
            
                                window.onbeforeunload = function(){ window.scrollTo(0,0); }
                                window.location.reload();
                            },
                            error: function (request, textStatus, errorThrown) {
                                alert("Something went wrong: " + errorThrown);
                                dialog.modal('hide');
                            }
                        });
                    },
                }
            });
        }
        else { // logged in form
            function submitForm(duplicate, dialog) {
                $('.modal-body', dialog).prepend(`<p>Uploading file(s), please wait...</p>`);

                $.ajax({
                    type: "POST",
                    url: getApiURL("translations"),
                    headers: { "Token": $.cookie('token_api') },
                    data: formData,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        let translationId = data.ID;
                        let translationRef = data.ref;
                        let requestType = data.request_quote ? "quote request" : "translation request";
                        if (attachmentsToLarge) { // warn user files were too large to be attached
                            ATLAlerts.addWarning(`The ${requestType} has been successfully created. However your filesize exceeded the limit size (${Math.round(MAX_FILES_UPLOAD_SIZE/1000000)}Mb). Please send directly the files to ATL administration.`);
                        }
                        else {
                            ATLAlerts.addSuccess(`The ${requestType} ${translationRef} has been successfully created.`);
                            attachmentsToSendLater.forEach(filename => {
                                ATLAlerts.addWarning(`Don't forget to send us the document ${filename}.`);
                            });
                        }
                        if (!duplicate) {
                            if (config.is_admin) {
                                window.location.href = config.app_url + "/all-translation-requests/";
                            } else {
                                window.location.href = config.app_url + "/clients/my-translations/";
                            }
                        }
                        else {
                            window.location.href = config.app_url + "/clients/new-translation-request/?translation_id=" + translationId;
                        }
                    },
                    error: function (request, textStatus, errorThrown) {
                        alert("Something went wrong: " + errorThrown);
                        dialog.modal('hide');
                    }
                });
            }

            const dialog = showBinaryChoiceDialog({
                title: "Make another translation request",
                body: "Do you want to make another translation request for the same claimant/client?",
                yesButton: {
                    title: "Confirm and make another request",
                    onClick: function () {
                        submitForm(true, dialog);
                    },
                },
                noButton: {
                    title: "Confirm",
                    onClick: function () {
                        submitForm(false, dialog);
                    },
                },
            });
        }
    });

});